var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state.sale.Contact
    ? _c(
        "w-scroll-page",
        { staticClass: "w-container" },
        [
          _c(
            "w-card",
            { attrs: { grow: "" } },
            [
              _c(
                "w-card-content",
                [
                  _c("app-default-settings", { attrs: { state: _vm.state } }),
                  _c(
                    "w-row",
                    { staticClass: "white", attrs: { block: "", stretch: "" } },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-select-sale-layout", {
                            staticClass: "mtl",
                            attrs: {
                              id: "",
                              label: _vm.$ct("layout-select"),
                              fancy: "",
                              "sale-type-id": _vm.state.sale.TypeID,
                              "add-default-option": "",
                            },
                            model: {
                              value: _vm.state.sale.LayoutID,
                              callback: function ($$v) {
                                _vm.$set(_vm.state.sale, "LayoutID", $$v)
                              },
                              expression: "state.sale.LayoutID",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-custom-language-select", {
                            staticClass: "mtl",
                            attrs: {
                              label: _vm.$ct("language-select"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.state.sale.Lng,
                              callback: function ($$v) {
                                _vm.$set(_vm.state.sale, "Lng", $$v)
                              },
                              expression: "state.sale.Lng",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("app-total-box", { attrs: { sale: _vm.state.sale } }),
                ],
                1
              ),
              _c("w-spacer"),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      staticClass: "finish-icon",
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_c("span", { staticClass: "icon icon-floppy-disk" })]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }